import _extends from "@babel/runtime/helpers/extends";
import { Stack } from "@mui/material";
import { ChevronDownIcon } from "../../../../assets/customIcons";
import { Search } from "../../../assets/svg";
import InfoIcon from "./cellInfoIcon";
export default function GridCellWrapper(params) {
    var info = params.info, formattedValue = params.formattedValue, colDef = params.colDef, tabIndex = params.tabIndex, cell = params.cell, isEditable = params.isEditable, aggregation = params.aggregation;
    var title = info === null || info === void 0 ? void 0 : info(params);
    return /*#__PURE__*/ React.createElement(Stack, _extends({
        tabIndex: tabIndex,
        sx: {
            ':focus-visible': {
                outline: 'none'
            }
        },
        direction: "row",
        alignItems: "center",
        justifyContent: colDef.align,
        columnGap: 1,
        height: "100%",
        px: 2,
        title: formattedValue
    }, aggregation && {
        height: 32,
        bgcolor: 'white',
        my: 0.75
    }), colDef.type === 'searchSelect' && isEditable ? /*#__PURE__*/ React.createElement(Search, {
        id: "cell-icon",
        color: "secondary"
    }) : null, cell !== null && cell !== void 0 ? cell : formattedValue, title && /*#__PURE__*/ React.createElement(InfoIcon, {
        title: title
    }), colDef.type === 'singleSelect' && isEditable ? /*#__PURE__*/ React.createElement(ChevronDownIcon, {
        id: "cell-icon",
        color: "secondary"
    }) : null);
}
